const BASE_API = process.env.MIX_ENDLESS_API_URL

/**
 * Liste uçları resource collection döndürüyor: {result: {data: [...]}}.
 * Tekil uçlar ise doğrudan {result: {...}} veriyor. Her koşulda dizi döndür —
 * nesne atanırsa v-for yanlış döner ve render patlar.
 */
const asList = (payload) => {
	if (Array.isArray(payload)) {
		return payload
	}

	return (payload && Array.isArray(payload.data)) ? payload.data : []
}

const state = {
	assignments: null,
	loadingAssignments: false,
	// Materyaller atanmaz: öğrencinin kategorilerine uyanlar otomatik gelir.
	materials: null,
	loadingMaterials: false,
	// Çözülmekte olan deneme: sorular ve verilen cevaplar burada durur.
	runner: null,
	saving: false,
	result: null,
}

const getters = {
	assignmentsGetter: ({assignments}) => assignments,
	loadingAssignmentsGetter: ({loadingAssignments}) => loadingAssignments,
	materialsGetter: ({materials}) => materials,
	loadingMaterialsGetter: ({loadingMaterials}) => loadingMaterials,
	runnerGetter: ({runner}) => runner,
	savingGetter: ({saving}) => saving,
	resultGetter: ({result}) => result,
}

const mutations = {
	setAssignments: (state, payload) => state.assignments = payload,
	setLoadingAssignments: (state, payload) => state.loadingAssignments = payload,
	setMaterials: (state, payload) => state.materials = payload,
	setLoadingMaterials: (state, payload) => state.loadingMaterials = payload,
	setRunner: (state, payload) => state.runner = payload,
	setSaving: (state, payload) => state.saving = payload,
	setResult: (state, payload) => state.result = payload,
	setAnswer: (state, {questionId, optionIds, openAnswer}) => {
		if (!state.runner) {
			return
		}

		state.runner = {
			...state.runner,
			answers: {
				...state.runner.answers,
				[questionId]: {optionIds: optionIds || [], openAnswer: openAnswer || null},
			},
		}
	},
}

const actions = {
	async getAssignments({commit}) {
		commit('setLoadingAssignments', true)

		try {
			const res = await this.$axios.get(`${BASE_API}/digital-tests/assignments`)

			commit('setAssignments', asList(res.data.result))
		} finally {
			commit('setLoadingAssignments', false)
		}
	},

	/**
	 * Materyaller danışman tarafından atanmaz; öğrencinin kategorileriyle
	 * eşleşen aktif materyaller sunucuda hesaplanıp döner.
	 */
	async getMaterials({commit}) {
		commit('setLoadingMaterials', true)

		try {
			const res = await this.$axios.get(`${BASE_API}/digital-tests/materials`)

			commit('setMaterials', asList(res.data.result))
		} finally {
			commit('setLoadingMaterials', false)
		}
	},

	/**
	 * Danışmandan gelen linkin token'ı ile testi açar. Atama başka bir öğrenciye
	 * aitse API 403 döner ve burada yakalanır.
	 */
	async openAssignment({commit}, token) {
		const res = await this.$axios.get(`${BASE_API}/digital-tests/assignments/${token}`)

		return res.data.result
	},

	async startTest({commit}, token) {
		commit('setSaving', true)

		try {
			const res = await this.$axios.post(`${BASE_API}/digital-tests/assignments/${token}/start`)
			const result = res.data.result

			commit('setRunner', {
				token,
				attempt: result.attempt,
				questions: result.questions,
				// Yarım kalmış denemede verilmiş cevaplar geri yüklenir.
				answers: (result.attempt.answers || []).reduce((carry, answer) => {
					carry[answer.question_id] = {
						optionIds: answer.option_ids || [],
						openAnswer: answer.open_answer,
					}

					return carry
				}, {}),
				index: 0,
			})

			return result
		} finally {
			commit('setSaving', false)
		}
	},

	/**
	 * Her cevap anında sunucuya yazılır; bağlantı koparsa en fazla eldeki soru
	 * kaybolur.
	 */
	async saveAnswer({commit, state}, {questionId, optionIds, openAnswer}) {
		commit('setAnswer', {questionId, optionIds, openAnswer})

		await this.$axios.post(`${BASE_API}/digital-tests/attempts/${state.runner.attempt.attempt_id}/answer`, {
			question_id: questionId,
			option_ids: optionIds || [],
			open_answer: openAnswer || null,
		})
	},

	async finishTest({commit, state, dispatch}) {
		commit('setSaving', true)

		try {
			const res = await this.$axios.post(`${BASE_API}/digital-tests/attempts/${state.runner.attempt.attempt_id}/finish`)
			commit('setResult', res.data.result)
			commit('setRunner', null)
			await dispatch('getAssignments')

			return res.data.result
		} finally {
			commit('setSaving', false)
		}
	},

	/**
	 * Referans PDF için kısa ömürlü imzalı bağlantı; her tıklamada taze alınır.
	 */
	async getReferencePdfUrl(context, attemptId) {
		const res = await this.$axios.get(`${BASE_API}/digital-tests/attempts/${attemptId}/reference-pdf-link`)

		return res.data.result.url
	},

	async getResult({commit}, attemptId) {
		const res = await this.$axios.get(`${BASE_API}/digital-tests/attempts/${attemptId}/result`)
		commit('setResult', res.data.result)

		return res.data.result
	},
}

export default {namespaced: true, state, getters, mutations, actions}
